module.exports = __webpack_public_path__ + "img/attach-detach.b44ba4da.svg";